const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3SoundPlus {
    constructor(runtime) { this.runtime = runtime; this._vol = 100; }
    getInfo() {
        return {
            id: 'soundPlus', name: '🔊 サウンド+', color1: '#CF63CF', color2: '#BD42BD',
            blocks: [
                { opcode: 'setVol', blockType: BlockType.COMMAND, text: '全体の音量を [V]%', arguments: { V: { type: ArgumentType.NUMBER, defaultValue: 100 } } },
                { opcode: 'getVol', blockType: BlockType.REPORTER, text: '全体の音量' },
                { opcode: 'playFreq', blockType: BlockType.COMMAND, text: '[F]Hz を [S]秒再生', arguments: { F: { type: ArgumentType.NUMBER, defaultValue: 440 }, S: { type: ArgumentType.NUMBER, defaultValue: 0.5 } } },
                { opcode: 'stopAll', blockType: BlockType.COMMAND, text: 'すべての音を止める' }
            ]
        };
    }
    setVol(args) { this._vol = Math.max(0, Math.min(100, Cast.toNumber(args.V))); }
    getVol() { return this._vol; }
    playFreq(args) { try { var ctx = new (window.AudioContext || window.webkitAudioContext)(); var osc = ctx.createOscillator(); var gain = ctx.createGain(); osc.connect(gain); gain.connect(ctx.destination); osc.frequency.value = Cast.toNumber(args.F); gain.gain.value = this._vol / 100; osc.start(); osc.stop(ctx.currentTime + Cast.toNumber(args.S)); } catch(e) {} }
    stopAll() { if (this.runtime) this.runtime.targets.forEach(function(t) { if (t.stopAllSounds) t.stopAllSounds(); }); }
}
module.exports = Scratch3SoundPlus;